module.exports = __webpack_public_path__ + "static/home-callout-03-46bd2280dabeb9bb52b06b1987c50bf2.jpg";